import script from "./average-order-list.vue?vue&type=script&lang=tsx&setup=true"
export * from "./average-order-list.vue?vue&type=script&lang=tsx&setup=true"

const __exports__ = script;

export default __exports__